"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashCode = void 0;
function hashCode(s) {
    let hash = 0;
    if (s.length === 0)
        return hash;
    for (let i = 0; i < s.length; i++) {
        const chr = s.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
}
exports.hashCode = hashCode;
